import { SelectChangeEvent } from "@mui/material";
import { useState } from "react";
import useEvent from "react-use-event-hook";

import { REPORT_CHART_DEFAULT_DISPLAY_MODE } from "./report-chart.constants";
import { ReportChartDisplayMode } from "./report-chart.models";
import {
  isReportChartPieMode,
  normalizeReportChartDisplayMode,
  parseReportChartMaxItems,
} from "./report-chart.utils.display";

export const useReportChartToolbar = () => {
  const [displayMode, setDisplayMode] = useState<ReportChartDisplayMode>(
    REPORT_CHART_DEFAULT_DISPLAY_MODE,
  );
  const [maxItemsInput, setMaxItemsInput] = useState("");
  const [appliedMaxItems, setAppliedMaxItems] = useState<number | undefined>(
    undefined,
  );
  const [refreshSeed, setRefreshSeed] = useState(0);
  const [displayGrid, setDisplayGrid] = useState(false);
  const [hideLabels, setHideLabels] = useState(false);

  const applyMaxItems = useEvent(() => {
    setAppliedMaxItems(parseReportChartMaxItems(maxItemsInput));
  });

  const onDisplayModeChange = useEvent((event: SelectChangeEvent<string>) => {
    const mode = normalizeReportChartDisplayMode(event.target.value);
    setDisplayMode(mode);
    if (isReportChartPieMode(mode)) {
      setDisplayGrid(false);
    }
  });

  const onMaxItemsInputChange = useEvent((value: string) => {
    setMaxItemsInput(value);
  });

  const onMaxItemsBlur = useEvent(() => {
    applyMaxItems();
  });

  const onRefresh = useEvent(() => {
    applyMaxItems();
    setRefreshSeed(seed => seed + 1);
  });

  const onDisplayGridChange = useEvent((checked: boolean) => {
    setDisplayGrid(checked);
  });

  const onHideLabelsChange = useEvent((checked: boolean) => {
    setHideLabels(checked);
  });

  return {
    displayMode,
    maxItemsInput,
    appliedMaxItems,
    refreshSeed,
    displayGrid,
    hideLabels,
    onDisplayModeChange,
    onMaxItemsInputChange,
    onMaxItemsBlur,
    onRefresh,
    onDisplayGridChange,
    onHideLabelsChange,
  };
};
